import {ActionCreator, NotAllowedCheck, TypedAction} from '@ngrx/store/src/models';
import {createAction, props} from '@ngrx/store';


export const postChatMessage: ActionCreator<string, (props: {userIds: string[], blocks: string} &
  NotAllowedCheck<{userIds: string[], blocks: string}>) => {userIds: string[], blocks: string} & TypedAction<string>> = createAction(
  '[Slack] Post Chat Message',
  props<{userIds: string[], blocks: string}>()
);
